import { render, staticRenderFns } from "./spacer.vue?vue&type=template&id=267bdfa6&scoped=true&lang=pug&"
import script from "./spacer.vue?vue&type=script&lang=coffee&"
export * from "./spacer.vue?vue&type=script&lang=coffee&"
import style0 from "./spacer.vue?vue&type=style&index=0&id=267bdfa6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267bdfa6",
  null
  
)

export default component.exports